import AutoSave from '@anm/components/form/AutoSave';
import FormHelperText from '@anm/components/form/FormHelperText';
import { TextField } from '@anm/components/form/fields';
import { UserFormRow } from '@anm/styles/helpers';
import { Config as FinalFormConfig } from 'final-form';
import { Omit } from 'helpers';
import noop from 'lodash/fp/noop';
import { FC } from 'react';
import { Form } from 'react-final-form';

import { FormWrapper } from './Wrapper';

export type BillingInfoFormFields = {
  zip: string;
  city: string;
  state: string;
  country: string;
  company: string;
  addressLine: string;
  taxInfo?: string;
};

export type BillingInfoFormProps = Omit<FinalFormConfig<BillingInfoFormFields>, 'onSubmit'> & {
  onAutoSave: (fields: BillingInfoFormFields) => void;
  submitError?: string | null;
};

const renderForm = ({ submitError, onAutoSave }: BillingInfoFormProps) => () => (
  <FormWrapper onSubmit={event => event.preventDefault()}>
    <AutoSave debounce={1000} onSave={onAutoSave} />
    {submitError && <FormHelperText variant="belowField">{submitError}</FormHelperText>}
    <UserFormRow>
      <TextField
        name="company"
        label="Company name"
        autocomplete="billing organization"
        helperTextVariant="belowField"
      />
    </UserFormRow>
    <UserFormRow>
      <TextField
        name="addressLine"
        label="Address"
        autocomplete="billing street-address"
        helperTextVariant="belowField"
      />
      <TextField name="city" label="City" autocomplete="billing address-level2" helperTextVariant="belowField" />
    </UserFormRow>
    <UserFormRow>
      <TextField name="state" label="State" autocomplete="billing address-level1" helperTextVariant="belowField" />
      <TextField
        name="zip"
        label="ZIP / Postal code"
        autocomplete="billing postal-code"
        helperTextVariant="belowField"
      />
      <TextField name="country" label="Country" autocomplete="billing country-name" helperTextVariant="belowField" />
    </UserFormRow>
    <UserFormRow>
      <TextField name="taxInfo" label="Tax information" helperTextVariant="belowField" />
    </UserFormRow>
  </FormWrapper>
);

const BillingInfoForm: FC<BillingInfoFormProps> = props => (
  <Form onSubmit={noop} render={renderForm(props)} {...props} />
);

export default BillingInfoForm;
